<div class="annotation pr-6 pr-96px pt-3" role="main">
  <h1 class="h-1 h-48px mb-2-4rem-imp">{{Annotationheader}}</h1>
  <mat-accordion>
    <mat-expansion-panel [expanded]="false">
      <mat-expansion-panel-header class="mataccordianHeader">
        <div class="matheadertext"> {{accordionRows[0] +" ("+ dataSourceCod.data.length +")"}}</div>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="dataSourceCod" matSort #TableOneSort="matSort" matSortActive="ParagraphId" matSortDirection="asc"  aria-describedby="annotations1">
        <ng-container matColumnDef="AnnotationTitle">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnone}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCod?.active=='AnnotationTitle'?'#F0F5FF':null"> {{element.AnnotationTitle}} </td>
        </ng-container>

        <ng-container matColumnDef="Annotation">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{annotationcolumntwo}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCod?.active=='Annotation'?'#F0F5FF':null">
            {{element.Annotation}}
          </td>
        </ng-container>

        <ng-container matColumnDef="ParagraphId">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnthree}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCod?.active=='ParagraphId'?'#F0F5FF':null">
            <span *ngFor="let items of element.Location; let i = index">
              <span *ngIf="i != element.Location.length-1" [innerHTML]="items| shortText : 30"></span>
              <img *ngIf="i != element.Location.length-1 && i != element.Location.length-2" class="arrow" alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" />
            </span><span><img class="arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right Down"></span>
            <br />
            <span class="link font-18 highlight-blue underline cursor-pointer"  (click)="NavigateTo(element.AnnotationsURL,element.Location[element.Location.length-1])" (keyup.enter)="NavigateTo(element.AnnotationsURL,element.Location[element.Location.length-1])" [innerHTML]="element.Location[element.Location.length-1].split('____')[0]"></span>

          </td>
        </ng-container>

        <ng-container matColumnDef="Date">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnfour}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCod?.active=='Date'?'#F0F5FF':null"> {{element.Date | date:'MM/dd/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{annotationcolumnfive}}</th>
          <td mat-cell *matCellDef="let element">
            <button aria-label="edit" mat-icon-button (click)="editAnnotations(element.id)">
              <mat-icon class="edit-icon"></mat-icon>
            </button>
            <button aria-label="copy" mat-icon-button (click)="copyToClipboard(element.AnnotationsURL,element.Annotation, element.Location,element.ParagraphId)">
              <mat-icon class="copy-clipboard-icon"></mat-icon>
            </button>
            <button aria-label="delete" mat-icon-button (click)="redirectToDelete(element.id)">
              <mat-icon class="delete-icon"></mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="dataSourceCod.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
      <div>
        <mat-paginator  #TableOnePaginator="matPaginator" [pageSize]="pagesize" [pageSizeOptions]="pagelistarrayCod"
                       aria-label="Select page of Annotations">
        </mat-paginator>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="mataccordianHeader">
        <div class="matheadertext"> {{accordionRows[1] +" ("+ dataSourceOP.data.length +")"}}</div>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="dataSourceOP" matSort #TableTwoSort="matSort" matSortActive="ParagraphId" matSortDirection="asc" aria-describedby="annotations2">
        <ng-container matColumnDef="AnnotationTitle">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnone}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortOP?.active=='AnnotationTitle'?'#F0F5FF':null"> {{element.AnnotationTitle}} </td>
        </ng-container>

        <ng-container matColumnDef="Annotation">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{annotationcolumntwo}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortOP?.active=='Annotation'?'#F0F5FF':null">
            {{element.Annotation}}
          </td>
        </ng-container>

        <ng-container matColumnDef="ParagraphId">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnthree}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortOP?.active=='ParagraphId'?'#F0F5FF':null">
            <span *ngFor="let items of element.Location; let i = index">
              <span *ngIf="i != element.Location.length-1" [innerHTML]="items| shortText : 30"></span>
              <img *ngIf="i != element.Location.length-1 && i != element.Location.length-2" class="arrow" alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" />
            </span><span><img class="arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right Down"></span>
            <br />
            <span class="link font-18 highlight-blue underline cursor-pointer" (click)="NavigateTo(element.AnnotationsURL,element.Location[element.Location.length-1])" (keyup.enter)="NavigateTo(element.AnnotationsURL,element.Location[element.Location.length-1])" [innerHTML]="element.Location[element.Location.length-1].split('____')[0]"></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="Date">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnfour}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortOP?.active=='Date'?'#F0F5FF':null"> {{element.Date | date:'MM/dd/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{annotationcolumnfive}}</th>
          <td mat-cell *matCellDef="let element">
            <button aria-label="edit" mat-icon-button (click)="editAnnotations(element.id)">
              <mat-icon class="edit-icon"></mat-icon>
            </button>
            <button aria-label="copy" mat-icon-button (click)="copyToClipboard(element.AnnotationsURL,element.Annotation, element.Location,element.ParagraphId)">
              <mat-icon class="copy-clipboard-icon"></mat-icon>
            </button>
            <button aria-label="delete" mat-icon-button (click)="redirectToDelete(element.id)">
              <mat-icon class="delete-icon"></mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="dataSourceOP.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
      <div>
        <mat-paginator #TableTwoPaginator="matPaginator" [pageSize]="pagesize" [pageSizeOptions]="pagelistarrayOP"
                       aria-label="Select page of Annotations">
        </mat-paginator>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <mat-expansion-panel >
      <mat-expansion-panel-header class="mataccordianHeader">
        <div class="matheadertext"> {{accordionRows[2]  +" ("+ dataSourceCIG.data.length +")"}}</div>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="dataSourceCIG" matSort #TableThreeSort="matSort" matSortActive="ParagraphId" matSortDirection="asc" aria-describedby="annotations3">
        <ng-container matColumnDef="AnnotationTitle">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnone}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCIG?.active=='AnnotationTitle'?'#F0F5FF':null"> {{element.AnnotationTitle}} </td>
        </ng-container>

        <ng-container matColumnDef="Annotation">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{annotationcolumntwo}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCIG?.active=='Annotation'?'#F0F5FF':null">
            {{element.Annotation}}
          </td>
        </ng-container>

        <ng-container matColumnDef="ParagraphId">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnthree}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCIG?.active=='ParagraphId'?'#F0F5FF':null">
            <span *ngFor="let items of element.Location; let i = index">
              <span *ngIf="i != element.Location.length-1"  [innerHTML]="items| shortText : 30"></span>
              <img *ngIf="i != element.Location.length-1 && i != element.Location.length-2" class="arrow" alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" />
            </span><span><img class="arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right Down"></span>
            <br />
            <span class="link font-18 highlight-blue underline cursor-pointer" (click)="NavigateTo(element.AnnotationsURL,element.Location[element.Location.length-1])" (keyup.enter)="NavigateTo(element.AnnotationsURL,element.Location[element.Location.length-1])" [innerHTML]="element.Location[element.Location.length-1].split('____')[0]"></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="Date">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnfour}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCIG?.active=='Date'?'#F0F5FF':null"> {{element.Date | date:'MM/dd/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th scope="col" mat-header-cell *matHeaderCellDef>{{annotationcolumnfive}}</th>
          <td mat-cell *matCellDef="let element">
            <button aria-label="edit" mat-icon-button (click)="editAnnotations(element.id)">
              <mat-icon class="edit-icon"></mat-icon>
            </button>
            <button aria-label="copy" mat-icon-button (click)="copyToClipboard(element.AnnotationsURL,element.Annotation, element.Location,element.ParagraphId)">
              <mat-icon class="copy-clipboard-icon"></mat-icon>
            </button>
            <button aria-label="delete" mat-icon-button (click)="redirectToDelete(element.id)">
              <mat-icon class="delete-icon"></mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="dataSourceCIG.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
      <div>
        <mat-paginator #TableThreePaginator="matPaginator" [pageSize]="pagesize" [pageSizeOptions]="pagelistarrayCIG"
                       aria-label="Select page of Annotations">
        </mat-paginator>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

</div>
